// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"eb682d14","822":"74cc13ae"}[chunkId] + ".chunk.js";
};